import { useEffect, useState } from 'react';
import { getOfferDeadline } from '../utils/offerDeadline';

export function useCountdown() {
  const [targetMs] = useState(getOfferDeadline);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const diff = Math.max(0, targetMs - now);

  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
    expired: diff === 0,
  };
}
